export default "__VITE_ASSET__xsOVNVeo__"